import { isEqual } from 'lodash';

const emptyArray = [];
const arrayCache = {};

export const cacheArray = (key, array) => {
  // if the array is empty, return the shared empty array to avoid unnecessary
  // updates
  if (array.length === 0) return emptyArray;

  const cached = arrayCache[key];

  // if we don't have an entry, or the array has changed in length, return the
  // new array and cache it.
  if (!arrayCache[key] || array.length != cached.length) return (arrayCache[key] = array);

  // if the arrays are deep equal, return the cached one. This should create
  // zero updates.
  if (isEqual(array, cached)) return cached;

  // per item, return the cached one if they're the same
  const result = array.map((item, index) => (isEqual(item, cached[index]) ? cached[index] : item));

  return (arrayCache[key] = result);
};
